import { openErrorToaster, openErrorWireToaster } from 'utils/common-services/toaster.service'
import { getTranslatedErrorMessage, getTranslation } from 'utils/common-services/translations.service'
import errorMessages from 'network/messages/errorMessages'
import store from 'index'
import { stopLoader } from 'redux-store/redux/slices/loader.slice'

// Late cash-out races (auto/resolve already settled, or crash) — no noisy toaster
const SILENT_ESCAPE_RACE_ERROR_CODES = new Set([
  3015, // NoPlacedBetFoundError
  3086 // RoundNoLongerActiveError
])

export const errorHandler = (error) => {
  const url = error.response?.config?.url
  const isMineGame = url?.includes('/mine-game')
  const isEscapeCashout = url?.includes('player-escape-crash-game')
  const apiErrorCode = error.response?.data?.errors?.[0]?.errorCode
  const silentEscapeRace = isEscapeCashout && SILENT_ESCAPE_RACE_ERROR_CODES.has(apiErrorCode)

  if (error.response.status === 500) {
    // Snackbar Internal Server Error
    isMineGame ? openErrorWireToaster({ message: getTranslation(errorMessages.internalServerError) }) : openErrorToaster({ message: getTranslation(errorMessages.internalServerError) })
    store.dispatch(stopLoader(error.response.config.loader))
    return Promise.reject(error.response.data.errors)
  } else if (error.response.status === 401 || error.response.status === 403) {
    // Snackbar UnAuthenticated
    isMineGame ? openErrorWireToaster({ message: error.response.data.errors[0].name === 'InsufficientFundsError' ? getTranslation(errorMessages.insufficientFund) : getTranslation(errorMessages.unAuthorized) }) : openErrorToaster({ message: error.response.data.errors[0].name === 'InsufficientFundsError' ? getTranslation(errorMessages.insufficientFund) : getTranslation(errorMessages.unAuthorized) })
    store.dispatch(stopLoader(error.response.config.loader))
    return Promise.reject(error.response.data.errors)
  } else if (error.response.config?.loader) {
    // Other errors
    store.dispatch(stopLoader(error.response.config.loader))
  }
  // Open Error Toaster (skip expected cash-out race conditions)
  const errorMessage = error.response.data.errors[0].description
  if (apiErrorCode !== 3008 && !silentEscapeRace) {
    errorMessage
      ? isMineGame ? openErrorWireToaster({ message: errorMessage }) : openErrorToaster({ message: errorMessage })
      : isMineGame ? openErrorWireToaster({ message: getTranslatedErrorMessage(apiErrorCode) }) : openErrorToaster({ message: getTranslatedErrorMessage(apiErrorCode) })
  }
  return Promise.reject(error.response.data.errors)
}
